export default {
    apply: 'Ok',
    cancel: 'Limpio',
    from: 'Del',
    to: 'Al',
    customRangeLabel: 'Período',
    ranges: {
        last_7_days: 'Los Últimos 7 Días',
        last_30_days: 'Los Últimos 30 Días',
        current_month: 'Mes Corriente',
        last_month: 'Mes Pasado',
        current_year: 'Año Corriente',
        last_year: 'Año Pasado',
    },
}
